export const size = {
  MIN_WIDTH_410: "(min-width:410px)",
  MAX_WIDTH_420: "(max-width:420px)",
  MAX_WIDTH_375: "(max-width:375px)",
  MAX_WIDTH_497: "(max-width:497px)",
}
